export default "__VITE_ASSET__R1Lhz9il__"